<template>
  <div>
    <div class="gap-3x" />
    <div class="question">
      <div :class="['flex-box', 'wrap', klass]">
        <div class="calc-left">
          <div class="body-16 bold">
            {{question}}
            <div v-if="smallNote" class="small-text">{{smallNote}}</div>
            <div v-if="error" class="error-message">{{error}}</div>
          </div>
        </div>
        <div class="calc-right">
          <slot></slot>
        </div>
      </div>
    </div>
    <div class="gap-3x" v-if="!noGap" />
    <div class="line-break" v-if="!noBorder" />
  </div>

</template>

<script>

export default {
  props: [
    "question", "klass", 'smallNote', "error", "noBorder", "noGap"
  ],
}
</script>

<style lang="scss" scoped>
.small-text {
  margin-top: 8px;
}
</style>
